import { network } from 'services/network';

export const deleteActivityCodeAliasById = (id) => {
    const url = `api/bo/deleteActivityCodeAliasById?id=${id}`;
    return network.post(url).then((response) => response.data);
};
